import actions from "./actions";

const initState = {
    activationResult: [],
    loading: false,
    error: null,
    buttonLoading: false,
    typeCodelist: [],
};

export default function reducer(state = initState, action) {
    switch (action.type) {
        case actions.GET_ACTIVATION_REPORT:
            return {
                ...state,
                loading: true,
                error: null,
                buttonLoading: true
            };
        case actions.GET_ACTIVATION_REPORT_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                activationResult: action.payload.activationResult,
            };
        case actions.GET_ACTIVATION_REPORT_FAILED:
            return {
                ...state,
                loading: false,
                error: action.error,
            };

        case actions.GET_TYPE_CODE:
            return {
                ...state,
            };
        case actions.GET_TYPE_CODE_SUCCESS:
            return {
                ...state,
                typeCodelist: action.result
            };
        case actions.GET_TYPE_CODE_FAILED:
            return {
                ...state,
                error: action.error
            };
        default:
            return state;
    }
}